import React, { useState } from "react";
import PropTypes from 'prop-types';

import styles from './tab.module.css';
/**
 * 
 * @param {number} value The current selected tab
 * @param {object} indicatorStyle style to control the display of indicator
 * @returns 
 */
const Tabs = ({children, fullWidth,value,handleChange,className,indicatorStyle, ...props}) => {
    
    const [active, setActive] = useState(value);
    const handleClick =(index) => (e) => {
        setActive(index);
        handleChange?.(e,index);
    }

    return (
        <div className={`${styles.Tabs} ${className} ${fullWidth ? styles.fullWidth : ""}` } {...props} >
            {React.Children.map(children,(child, index) => {
                return (
                    <div className={`${styles.TabContainer}`} >
                        {React.cloneElement(child, {onClick:handleClick(index), active:active === index})}
                        <div className={`${styles.indicatorStyle} ${active === index ? styles.active : ""}`} style={active === index ?indicatorStyle:{}}></div>
                    </div>
                )
            })}
        </div>
    )
}

export default Tabs;